<body>
  <div class="container-fluid">
    <div class="row">
      <div class="col-11 d-flex bar">
        <div class="radiobtn">
          <label [class.active-tab]="selectedTab === 'all'"
            class="tab d-flex justify-content-center align-items-center">
            <input type="radio" name="tab" hidden [checked]="selectedTab === 'all'" (change)="selectTab('all')" />
            <span class="">All Users</span>
            <span *ngIf="selectedTab == 'all'" class="tickitnumber">{{
              totalAll
              }}</span>
          </label>

          <label [class.active-tab]="selectedTab === 'tourist'"
            class="tab d-flex justify-content-center align-items-center">
            <input type="radio" name="tab" hidden [checked]="selectedTab === 'tourist'"
              (change)="selectTab('tourist')" />
            <span class="">Tourists</span>
            <span *ngIf="selectedTab == 'tourist'" class="tickitnumber">{{
              totalAll
              }}</span>
          </label>

          <label [class.active-tab]="selectedTab === 'tour'"
            class="tab d-flex justify-content-center align-items-center">
            <input type="radio" name="tab" hidden [checked]="selectedTab === 'tour'" (change)="selectTab('tour')" />
            <span class="">Tour Guides</span>
            <span *ngIf="selectedTab == 'tour'" class="tickitnumber">{{
              totalAll
              }}</span>
          </label>

          <label [class.active-tab]="selectedTab === 'Application'"
            class="tab d-flex justify-content-center align-items-center">
            <input type="radio" name="tab" hidden [checked]="selectedTab === 'Application'"
              (change)="selectTab('Application')" />
            <span class="">Application Review</span>
            <span *ngIf="selectedTab == 'Application'" class="tickitnumber">{{
              totalaproveuser
              }}</span>
          </label>

          <label [class.active-tab]="selectedTab === 'ChangeRequest'"
            class="tab d-flex justify-content-center align-items-center">
            <input type="radio" name="tab" hidden [checked]="selectedTab === 'ChangeRequest'"
              (change)="selectTab('ChangeRequest')" />
            <span class="">Change Request</span>
            <span *ngIf="selectedTab == 'ChangeRequest'" class="tickitnumber">{{
              totalChangeRequests
              }}</span>
          </label>

          <label [class.active-tab]="selectedTab === 'RejectedApplication'"
            class="tab d-flex justify-content-center align-items-center">
            <input type="radio" name="tab" hidden [checked]="selectedTab === 'RejectedApplication'"
              (change)="selectTab('RejectedApplication')" />
            <span class="">Rejected Applications</span>
            <span *ngIf="selectedTab == 'RejectedApplication'" class="tickitnumber">{{
              totalRejectedApps
              }}</span>
          </label>
        </div>
      </div>
    </div>

    <div class="row g-0 mainrow">
      <div class="col-11 main-table" *ngIf="selectedTab !== 'Application' && selectedTab !== 'ChangeRequest' && selectedTab !== 'RejectedApplication'">
        <!-- Top Bar -->
        <div class="table-bar border-bottom d-flex justify-content-between align-items-center py-2 px-2">
          <h5 *ngIf="selectedTab == 'all'">All Users</h5>
          <h5 *ngIf="selectedTab == 'tourist'">Tourist</h5>
          <h5 *ngIf="selectedTab == 'tour'">Tour Guides</h5>

          <div class="table-controls d-flex align-items-center gap-2">
            <div class="position-relative w-100" style="max-width: 400px">
              <div class="search-wrapper d-flex rounded mb-3 position-relative">
                <img class="table-img me-2" src="/assets/userIcon/searchIcon.png" alt="Search" width="16" height="16" />
                <input class="input-search" type="text" placeholder="Search by name or email id"
                  [(ngModel)]="searchText" (ngModelChange)="onSearch('all', searchText)" />
              </div>

              <!-- Search Result Dropdown -->
              <ul *ngIf="searchText && getuserarr.length > 0"
                class="search-result-list position-absolute bg-white border rounded w-100 p-2 mt-1"
                style="z-index: 1000; max-height: 200px; overflow-y: auto">
                <li *ngFor="let user of getuserarr" class="py-1 px-2 border-bottom" style="cursor: pointer"
                  data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight"
                  (click)="openUserProfile(user)">
                  <strong>{{ user.firstName }}</strong><br />
                  <small class="text-muted">{{ user.email }}</small>
                </li>
              </ul>

              <p *ngIf="searchText && getuserarr.length === 0" class="text-muted mt-2 mb-0 small">
                No users found.
              </p>
            </div>
          </div>
        </div>

        <div class="user-table-wrapper">
          <div class="scrollable-table-wrapper">
            <table class="table align-middle mb-0">
              <thead class="custom-head trow sticky-top bg-white">
                <tr>
                  <th style="width: 51%">User</th>
                  <th style="width: 15%; padding-left: 1rem">Role</th>
                  <th style="width: 14%">Status</th>
                  <th style="width: 12%">Join Date</th>
                  <th style="width: 17%">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="getuserarr?.length === 0">
                  <td colspan="7" class="text-center py-3 text-muted">
                    No User available.
                  </td>
                </tr>

                <tr *ngFor="let item of getuserarr">
                  <td style="width: 51%">
                    <div class="d-flex align-items-center gap-2">
                      <img [src]="
                          item.profilePhotoUrl || 'assets/userIcon/user.png'
                        " class="rounded-circle" width="40" height="40" />
                      <div>
                        <div class="fw-semibold text-truncate" style="width: 95%">
                          {{ item.firstName }} {{ item.lastName }}
                        </div>
                        <div class="text-muted small text-truncate" style="width: 95%">
                          {{ item.email }}
                        </div>
                      </div>
                    </div>
                  </td>

                  <td style="width: 15%; padding-left: 0">
                    <div class="tourist" *ngIf="item.roleId == 2">
                      <img src="/assets/userIcon/ToristIcon.svg" /> Tourist
                    </div>
                    <div class="guides" *ngIf="item.roleId == 3">
                      <img src="/assets/userIcon/BlueSheild.svg" /> Guide
                    </div>
                  </td>

                  <td style="width: 14%; padding-left: 0">
                    <span *ngIf="!item.isDeactivate" class="Active status">
                      <span class="dot"></span> Active
                    </span>
                    <span *ngIf="item.isDeactivate" class="Inactive status">
                      <span class="dot"></span> Inactive
                    </span>
                  </td>

                  <td style="width: 14%; padding-left: 0">
                    {{ item.createdAt | customDatePipe }}
                  </td>

                  <td style="width: 17%; padding-left: 0">
                    <div class="dropdown" style="margin-left: 1rem">
                      <button class="btn three-dot-btn p-0 text-muted fs-4" type="button" data-bs-toggle="dropdown">
                        ...
                      </button>
                      <ul class="dropdown-menu">
                        <li>
                          <a class="dropdown-item" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight"
                            (click)="openUserProfile(item)">View Details</a>
                        </li>
                        <li *ngIf="item.roleId == 3">
                          <a class="dropdown-item" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight0"
                            (click)="openUserProfile(item)">Edit</a>
                        </li>
                        <li>
                          <a class="dropdown-item text-danger" *ngIf="!item.isDeactivate"
                            (click)="Deactivateduser(item.userId)">Deactivate</a>
                          <a class="dropdown-item text-success" *ngIf="item.isDeactivate"
                            (click)="Activateduser(item.userId)">Activate</a>
                        </li>
                      </ul>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Pagination -->
          <div class="bottomtable d-flex justify-content-between mt-2">
            <app-pegination [pageAll]="pageAll" [totalPages]="totalPages" [pageSize]="pageSize"
              (pageChange)="goToallPage($event)" (sizeChange)="onSizeChanges($event)">
            </app-pegination>
          </div>
        </div>
      </div>

      <div class="col-11 main-table" *ngIf="selectedTab == 'Application'">
        <div class="table-bar border-bottom d-flex justify-content-between align-items-center py-2 px-2">
          <h5>Application Review</h5>

          <div class="table-controls d-flex align-items-center gap-2">
            <div class="position-relative w-100" style="max-width: 400px; margin: auto">
              <div class="position-relative w-100" style="max-width: 400px; margin: auto">
                <div class="search-wrapper d-flex rounded mb-3 position-relative">
                  <img class="table-img me-2" src="/assets/userIcon/searchIcon.png" alt="Search" width="16"
                    height="16" />
                  <input class="input-search" type="text" placeholder="Search by name or email id"
                    [(ngModel)]="searchguidetext" (ngModelChange)="onSearch('verifyguide', searchguidetext)" />
                </div>

                <ul *ngIf="searchguidetext && guideapprove.length > 0"
                  class="search-result-list position-absolute bg-white border rounded w-100 p-2 mt-1"
                  style="z-index: 1000; max-height: 200px; overflow-y: auto">
                  <li *ngFor="let user of guideapprove" class="py-1 px-2 border-bottom" style="cursor: pointer"
                    data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight23" aria-controls="offcanvasRight"
                    (click)="openGuideProfile(user)">
                    <strong>{{ user.firstName }}</strong><br />
                    <small class="text-muted">{{ user.email }}</small>
                  </li>
                </ul>

                <p *ngIf="searchguidetext && guideapprove.length === 0" class="text-muted mt-2 mb-0 small">
                  No users found.
                </p>
              </div>
            </div>

            <!-- Dropdown -->
          </div>
        </div>

        <div class="user-table-wrapper">
          <div class="scrollable-table-wrapper">
            <table class="table align-middle mb-0 border-1px">
              <thead class="custom-head">
                <tr>
                  <th scope="col" style="width: 70%">User</th>

                  <th scope="col">Join Date</th>
                  <th scope="col" style="width: 13%">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr class="No-req" *ngIf="guideapprove.length <= 0">
                  <td colspan="7" class="text-center py-3 text-muted">
                    No Tour Guide Request Available.
                  </td>
                </tr>

                <tr *ngFor="let item of guideapprove">
                  <td>
                    <div class="d-flex align-items-center gap-2">
                      <img [src]="
                          item.profilePhotoUrl || 'assets/userIcon/user.png'
                        " class="rounded-circle" width="40" height="40" />
                      <div>
                        <div class="fw-semibold">
                          {{ item.firstName }} {{ item.lastName }}
                        </div>
                        <div class="text-muted small">{{ item.email }}</div>
                      </div>
                    </div>
                  </td>

                  <td>{{ item.createdAt | customDatePipe }}</td>

                  <td>
                    <div class="dropdown" style="margin-right: 3px">
                      <div class="d-flex align-items-center">
                        <span>
                          <img src="assets/userIcon/Action.svg" data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasRight23" aria-controls="offcanvasRight"
                            (click)="openGuideProfile(item)" style="cursor: pointer; margin-left: 1rem" />
                        </span>
                      </div>

                      <ul class="dropdown-menu">
                        <li>
                          <a class="dropdown-item">View Profile</a>
                        </li>
                        <li><a class="dropdown-item">Edit</a></li>
                        <li>
                          <a class="dropdown-item text-danger" *ngIf="!item.isDeactivate" (click)="Deactivateduser(item.userId)">Deactivate</a>
                          <a class="dropdown-item text-success" *ngIf="item.isDeactivate" (click)="Activateduser(item.userId)">Activate</a>
                        </li>
                      </ul>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="bottomtable">
            <app-pegination [pageAll]="guidepage" [totalPages]="totalaprovepage" [pageSize]="pageSizeApproved"
              (pageChange)="approvegoToPage($event)" (sizeChange)="aproveonSizeChanges($event)">
            </app-pegination>
          </div>
        </div>
      </div>

      <div class="col-11 main-table" *ngIf="selectedTab == 'ChangeRequest'">
        <div class="table-bar border-bottom d-flex justify-content-between align-items-center py-2 px-2">
          <h5>Change Request</h5>

          <div class="table-controls d-flex align-items-center gap-2">
            <div class="position-relative w-100" style="max-width: 400px; margin: auto">
              <div class="position-relative w-100" style="max-width: 400px; margin: auto">
                <div class="search-wrapper d-flex rounded mb-3 position-relative">
                  <img class="table-img me-2" src="/assets/userIcon/searchIcon.png" alt="Search" width="16"
                    height="16" />
                  <input class="input-search" type="text" placeholder="Search by name or email id"
                    [(ngModel)]="changeRequestSearchText" (ngModelChange)="onSearch('changerequests', changeRequestSearchText)" />
                </div>
              </div>
            </div>
            
            <select class="form-select userdroup" style="width: auto" [(ngModel)]="changeRequestStatus" (change)="onChangeRequestStatus()">
              <option value="Approved">Approved</option>
              <option value="Pending">Pending</option>
              <option value="Rejected">Rejected</option>
            </select>
          </div>
        </div>

        <div class="user-table-wrapper">
           <div class="scrollable-table-wrapper">
             <table class="table align-middle mb-0 border-1px">
               <thead class="custom-head">
                 <tr>
                   <th scope="col" style="width: 25%">User</th>
                   <th scope="col" style="width: 20%">Contact</th>
                   <th scope="col" style="width: 20%">Requested At</th>
                   <th scope="col" style="width: 25%">Changes</th>
                   <th scope="col" style="width: 10%">Action</th>
                 </tr>
               </thead>
               <tbody>
                  <tr class="No-req" *ngIf="changeRequests.length <= 0">
                    <td colspan="5" class="text-center py-3 text-muted">
                      No Change Request Available.
                    </td>
                  </tr>

                  <tr *ngFor="let item of changeRequests">
                    <td>
                      <div class="d-flex align-items-center gap-2">
                        <img [src]="
                            item.profilePhotoUrl || 'assets/userIcon/user.png'
                          " class="rounded-circle" width="40" height="40" />
                        <div>
                          <div class="fw-semibold">
                            {{ item.fullName }}
                          </div>
                          <div class="text-muted small">{{ item.email }}</div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="text-muted small">{{ item.country }}</div>
                      <div class="text-muted small">{{ item.phoneNumber }}</div>
                    </td>
                    <td>{{ item.createdAt | customDatePipe }}</td>
                    <td>
                      <span class="badge bg-secondary me-1" *ngIf="item.hasVehicleChanges">Vehicle</span>
                      <span class="badge bg-info me-1" *ngIf="item.hasImageChanges">Image</span>
                      <span class="badge bg-success me-1" *ngIf="item.hasRateChanges">Rate</span>
                      <span class="badge bg-primary" *ngIf="item.hasDocumentChanges">Document</span>
                    </td>
                    <td>
                      <div class="d-flex align-items-center">
                        <img src="assets/userIcon/Action.svg" data-bs-toggle="offcanvas" data-bs-target="#offcanvasChangeRequest" (click)="openChangeRequest(item)" style="cursor: pointer; margin-left: 1rem" />
                      </div>
                    </td>
                  </tr>
               </tbody>
             </table>
           </div>
           <div class="bottomtable mt-2">
             <app-pegination [pageAll]="changeRequestPage" [totalPages]="totalChangeRequestPages" [pageSize]="changeRequestPageSize"
               (pageChange)="onChangeRequestsPage($event)" (sizeChange)="onChangeRequestsSize($event)">
             </app-pegination>
           </div>
        </div>
      </div>

      <div class="col-11 main-table" *ngIf="selectedTab == 'RejectedApplication'">
        <div class="table-bar border-bottom d-flex justify-content-between align-items-center py-2 px-2">
          <h5>Rejected Applications</h5>

          <div class="table-controls d-flex align-items-center gap-2">
            <div class="position-relative w-100" style="max-width: 400px; margin: auto">
              <div class="search-wrapper d-flex rounded mb-3 position-relative">
                <img class="table-img me-2" src="/assets/userIcon/searchIcon.png" alt="Search" width="16" height="16" />
                <input class="input-search" type="text" placeholder="Search by name or email"
                  [(ngModel)]="rejectedSearchText" (ngModelChange)="onSearch('rejectedapps', rejectedSearchText)" />
              </div>
            </div>
          </div>
        </div>

        <div class="user-table-wrapper">
          <div class="scrollable-table-wrapper">
            <table class="table align-middle mb-0 border-1px">
              <thead class="custom-head">
                <tr>
                  <th scope="col" style="width: 70%">User</th>
                  <th scope="col">Join Date</th>
                  <th scope="col" style="width: 13%">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr class="No-req" *ngIf="rejectedApplications.length <= 0">
                  <td colspan="5" class="text-center py-3 text-muted">
                    No Rejected Applications Available.
                  </td>
                </tr>

                <tr *ngFor="let item of rejectedApplications">
                  <td>
                    <div class="d-flex align-items-center gap-2">
                       <img [src]="item.profilePhotoUrl || 'assets/userIcon/user.png'" class="rounded-circle" width="40" height="40" />
                      <div>
                        <div class="fw-semibold">{{ item.firstName }} {{ item.lastName }}</div>
                        <div class="text-muted small">{{ item.email }}</div>
                      </div>
                    </div>
                  </td>
                  <td>{{ item.createdAt | customDatePipe }}</td>
                  <td>
                    <div class="d-flex align-items-center">
                      <img src="assets/userIcon/Action.svg" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight23" aria-controls="offcanvasRight" (click)="openGuideProfile(item)" style="cursor: pointer; margin-left: 1rem" />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="bottomtable mt-2">
            <app-pegination [pageAll]="rejectedPage" [totalPages]="totalRejectedPages" [pageSize]="rejectedPageSize"
              (pageChange)="onRejectedPageChange($event)" (sizeChange)="onRejectedSizeChange($event)">
            </app-pegination>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="guidePhotoPreviewModal" tabindex="-1" aria-labelledby="guidePhotoPreviewModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="guidePhotoPreviewModalLabel">Profile Photo</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body d-flex justify-content-center align-items-center">
          <img [src]="previewImageUrl || guideuser.profilePhotoUrl || 'assets/userIcon/user.png'"
            class="guide-profile-photo-preview" />
        </div>
      </div>
    </div>
  </div>

  <div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
    <div class="canva-head">
      <h5 class="offcanvas-title" id="offcanvasRightLabel">User Details</h5>
      <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"
        (click)="closeCanvas()"></button>
    </div>
    <div class="canva-body">
      <div class="container">
        <div class="row d-flex justify-content-center align-items-center">
          <div class="sub-headWrapper">
            <div class="col-12 d-flex radiobtn insidetab" style="background-color: #f6f6f6; gap: 20px">
              <div class="tab1" [ngClass]="{ 'active-tab': viewMode === 'overview' }" (click)="toggleView('overview')">
                <span class="d-flex justify-content-center align-items-center opentickit">
                  <span class="lbl-class">Overview</span>
                </span>
              </div>

              <div class="tab1" [ngClass]="{ 'active-tab': viewMode === 'history' }" (click)="toggleView('history')">
                <span class="d-flex justify-content-center align-items-center opentickit">
                  <span class="lbl-class">Booking History</span>
                </span>
              </div>

              <div *ngIf="getuserid.roleId === 3" class="tab1" [ngClass]="{
                  'active-tab':
                    viewMode === 'payout' || viewMode === 'vehicleDetails',
                }" (click)="toggleView('payout')">
                <span class="d-flex justify-content-center align-items-center opentickit">
                  <span class="lbl-class">Vehicle</span>
                </span>
              </div>

              <div *ngIf="getuserid.roleId === 3" class="tab1" [ngClass]="{
                'active-tab':
                  viewMode === 'documents',
              }" (click)="toggleView('documents')">
                <span class="d-flex justify-content-center align-items-center opentickit">
                  <span class="lbl-class">Documents</span>
                </span>
              </div>

              <div *ngIf="getuserid.roleId === 3" class="tab1" [ngClass]="{
                'active-tab':
                  viewMode === 'unavailability',
              }" (click)="toggleView('unavailability')">
                <span class="d-flex justify-content-center align-items-center opentickit">
                  <span class="lbl-class" style="white-space: nowrap;">Unavailable Dates</span>
                </span>
              </div>
            </div>
          </div>

          <div *ngIf="viewMode === 'overview'" class="canvas-section">
            <div class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-5">
              <div class="d-flex align-items-center gap-2">
                <img src="{{ getuserid.profilePhotoUrl }}" class="rounded-circle" width="40" height="40"
                  style="cursor: pointer" data-bs-toggle="modal" data-bs-target="#guidePhotoPreviewModal"
                  (click)="openPhotoPreview(getuserid.profilePhotoUrl)" />
                <div>
                  <div class="fw-semibold">
                    {{ getuserid.firstName }} {{ getuserid.lastName }}
                  </div>
                  <div class="text-muted small">{{ getuserid.email }}</div>
                </div>
              </div>

              <span *ngIf="!getuserid.isDeactivate" class="Active status">
                <span class="dot"></span> Active
              </span>
              <div *ngIf="getuserid.isDeactivate" class="d-flex align-items-center gap-2">
                <span class="Inactive status">
                  <span class="dot"></span> Inactive
                </span>
                <span class="text-primary text-decoration-underline" style="cursor: pointer; font-size: 14px;" (click)="Activateduser(getuserid.userId)">
                  Activate
                </span>
              </div>
            </div>
            <div
              class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-5 border-bottom">
              <p style="color: #6d6d6d">User Type</p>
              <div style="margin-bottom: 10px">
                <span class="tourist" *ngIf="getuserid.roleId == 2">
                  <img src="/assets/userIcon/tourist.png" class="me-1" />
                  Tourist
                </span>
                <span class="guides" *ngIf="getuserid.roleId == 3">
                  <img src="/assets/userIcon/Guide.png" class="me-1" />
                  Guide</span>
              </div>
            </div>

            <div *ngIf="getuserid.roleId == 3"
              class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-2 border-bottom">
              <p style="color: #6d6d6d">Rating</p>
              <span>
                <img src="/assets/bookingIcon/smallstar.svg" />
                {{
                getuserid.avgRating != null
                ? getuserid.avgRating.toFixed(1)
                : "Not Available"
                }}
              </span>
            </div>
            <div
              class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-2 border-bottom">
              <p style="color: #6d6d6d">First Name</p>
              <span>
                {{ getuserid.firstName }}
              </span>
            </div>
            <div
              class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-2 border-bottom">
              <p style="color: #6d6d6d">Last Name</p>
              <span>
                {{ getuserid.lastName }}
              </span>
            </div>
            <!-- <div
              class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-2 border-bottom ">
              <p style="color: #6D6D6D;">Display Name </p>
              <span>
                {{getuserid.firstName}}

              </span>

            </div> -->
            <div
              class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-2 border-bottom">
              <p style="color: #6d6d6d">Gender</p>
              <span>
                {{ getuserid.gender }}
              </span>
            </div>
            <div
              class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-2 border-bottom">
              <p style="color: #6d6d6d">Email</p>
              <span>
                {{ getuserid.email }}
              </span>
            </div>
            <div
              class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-2 border-bottom">
              <p style="color: #6d6d6d">Contact</p>
              <span> +{{ getuserid.dialCode }}{{ getuserid.phoneNumber }} </span>
            </div>
            <div *ngIf="getuserid.roleId === 3"
              class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-2 border-bottom">
              <p style="color: #6d6d6d">Service Location</p>
              <span> {{getuserid.location}}</span>
            </div>
            <div
              class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-2 border-bottom">
              <p style="color: #6d6d6d">Country</p>

              <span *ngIf="getuserid?.countryCode">
                <span class="fi" [ngClass]="'fi-' + getuserid.countryCode.toLowerCase()"></span>
                {{ getuserid.country }}
              </span>
              <span *ngIf="!getuserid?.countryCode">
                {{ getuserid.country }}
              </span>
            </div>
            <div
              class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-2 border-bottom">
              <p style="color: #6d6d6d">Home Town</p>
              <span>
                {{ getuserid.homeTown ? getuserid.homeTown : 'N/A' }}
              </span>
            </div>
            <div
              class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-2 border-bottom">
              <p style="color: #6d6d6d">Date of Birth</p>
              <span>
                {{ getuserid.dateOfBirth ? (getuserid.dateOfBirth | date:'MM/dd/yyyy') : 'N/A' }}
              </span>
            </div>
            <div *ngIf="getuserid.roleId === 3"
              class="col-12 d-flex justify-content-between align-items-start mt-2 border-bottom py-2">
              <p style="color: #6d6d6d; white-space: nowrap; margin-right: 15px; margin-bottom: 0px; padding-top: 5px;">Known Languages</p>

              <div class="d-flex flex-wrap gap-2 justify-content-end">
                <span *ngFor="let lang of getuserid.languages">
                  <span class="lang-name">{{ lang.languageName }}</span>
                </span>
              </div>
            </div>
          </div>

          <div *ngIf="viewMode === 'payout' && GuideVehicle" class="canvas-section">
            <div class="outer-wrapper">
              <div class="vehicle-details-wrapper">
                <div class="car-photo">
                  <img [src]="getFrontImageUrl()" alt="Car Photo" style="border-radius: 8px" width="100%"
                    height="100%" />
                </div>
                <div class="inner-vehicle-details">
                  <div class="car-name">
                    <span style="font-weight: 600">{{ GuideVehicle.vehicleBrandName }}
                      {{ GuideVehicle.vehicleModelName }}</span>
                  </div>

                  <div class="car-number" style="color: #6d6d6d">
                    {{ GuideVehicle.licensePlateNumber }}
                  </div>

                  <div class="car-summary">
                    <img src="/assets/userIcon/carIcon.svg" alt="Car Icon" />
                    <span>{{ GuideVehicle.noOfSeats }} Seats</span>
                    <span>{{ GuideVehicle.noOfDoors }} Doors</span>
                    <span *ngIf="GuideVehicle?.isAirConditioner">Air Conditioning</span>
                  </div>
                </div>
              </div>
              <div class="bttn-outer">
                <div class="details-btn" (click)="toggleView('vehicleDetails')">
                  <img src="/assets/userIcon/detailsIcon.svg" alt="Details Icon" width="24" height="24" />
                  <span style="color: #309eae; font-weight: 600">View Details</span>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="viewMode === 'vehicleDetails' && GuideVehicle == null" class="canvas-section canvas-empty">
            <p style="font-weight: 500; color: #6d6d6d">No Vehicle Found</p>
          </div>

          <div *ngIf="viewMode === 'vehicleDetails' && GuideVehicle != null" class="canvas-section">
            <div class="d-flex justify-content-end mb-3">
              <button *ngIf="!isEditingVehicle" class="btn btn-sm btn-outline-primary" (click)="startEditVehicle()">
                <i class="bi bi-pencil"></i> Edit Vehicle Defaults
              </button>
            </div>

            <!-- Read Only View -->
            <div *ngIf="!isEditingVehicle" class="vehicle-info-wrapper">
              <div
                class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-2 border-bottom">
                <p style="color: #6d6d6d">Vehicle Brand</p>
                <span>
                  {{ GuideVehicle.vehicleBrandName }}
                </span>
              </div>
              <div
                class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-2 border-bottom">
                <p style="color: #6d6d6d">Vehicle Model</p>
                <span>
                  {{ GuideVehicle.vehicleModelName }}
                </span>
              </div>
              <div
                class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-2 border-bottom">
                <p style="color: #6d6d6d">License Plate Number</p>
                <span>
                  {{ GuideVehicle.licensePlateNumber }}
                </span>
              </div>
              <div
                class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-2 border-bottom">
                <p style="color: #6d6d6d">No. Of Seats</p>
                <span>
                  {{ GuideVehicle.noOfSeats }}
                </span>
              </div>
              <div
                class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-2 border-bottom">
                <p style="color: #6d6d6d">Hourly Rate</p>
                <span>
                  {{ GuideVehicle.hourlyRate }}$
                </span>
              </div>

              <div
                class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-2 border-bottom">
                <p style="color: #6d6d6d">No. Of Doors</p>
                <span>
                  {{ GuideVehicle.noOfDoors }}
                </span>
              </div>
              <div
                class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-2 border-bottom">
                <p style="color: #6d6d6d">Air Conditioning</p>
                <span>
                  {{ GuideVehicle.isAirConditioner ? "Yes" : "No" }}
                </span>
              </div>
              <div
                class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-2 border-bottom">
                <p style="color: #6d6d6d">No. of Large Bags</p>
                <span>
                  {{ GuideVehicle.noOfLargeBags }}
                </span>
              </div>
              <div
                class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-2 border-bottom">
                <p style="color: #6d6d6d">No. of Small Bags</p>
                <span>
                  {{ GuideVehicle.noOfSmallBags }}
                </span>
              </div>
            </div>

            <!-- Edit View -->
            <div *ngIf="isEditingVehicle" class="vehicle-info-wrapper mt-3">
              <div class="row g-3">
                <div class="col-md-6">
                  <label class="form-label" style="color: #6d6d6d">Vehicle Brand</label>
                  <input type="text" class="form-control" [(ngModel)]="editVehicleData.vehicleBrandName" />
                </div>
                <div class="col-md-6">
                  <label class="form-label" style="color: #6d6d6d">Vehicle Model</label>
                  <input type="text" class="form-control" [(ngModel)]="editVehicleData.vehicleModelName" />
                </div>
                <div class="col-md-6">
                  <label class="form-label" style="color: #6d6d6d">License Plate Number</label>
                  <input type="text" class="form-control" [(ngModel)]="editVehicleData.licensePlateNumber" />
                </div>
                <div class="col-md-6">
                  <label class="form-label" style="color: #6d6d6d">Hourly Rate ($)</label>
                  <input type="number" class="form-control" [(ngModel)]="editVehicleData.hourlyRate" />
                </div>
                <div class="col-md-6">
                  <label class="form-label" style="color: #6d6d6d">No. Of Seats</label>
                  <input type="number" class="form-control" [(ngModel)]="editVehicleData.noOfSeats" />
                </div>
                <div class="col-md-6">
                  <label class="form-label" style="color: #6d6d6d">No. Of Doors</label>
                  <input type="number" class="form-control" [(ngModel)]="editVehicleData.noOfDoors" />
                </div>
                <div class="col-md-6">
                  <label class="form-label" style="color: #6d6d6d">No. of Large Bags</label>
                  <input type="number" class="form-control" [(ngModel)]="editVehicleData.noOfLargeBags" />
                </div>
                <div class="col-md-6">
                  <label class="form-label" style="color: #6d6d6d">No. of Small Bags</label>
                  <input type="number" class="form-control" [(ngModel)]="editVehicleData.noOfSmallBags" />
                </div>
                <div class="col-md-12 d-flex align-items-center mt-3">
                  <input class="form-check-input me-2" type="checkbox" [(ngModel)]="editVehicleData.isAirConditioner" id="isAcCheck">
                  <label class="form-check-label" for="isAcCheck" style="color: #6d6d6d">
                    Air Conditioning
                  </label>
                </div>
                <div class="col-md-12 mt-3">
                  <label class="form-label" style="color: #6d6d6d">Upload New Images (Max 5, replaces existing in order)</label>
                  <input type="file" class="form-control" multiple accept="image/*" (change)="onVehicleFilesSelected($event)" />
                  <div class="d-flex gap-2 mt-2 flex-wrap" *ngIf="editVehicleImagePreviews.length > 0">
                    <div *ngFor="let preview of editVehicleImagePreviews; let i = index" class="d-flex flex-column align-items-center position-relative">
                      <span class="small text-muted">{{preview?.type}}</span>
                      <img *ngIf="preview?.url" [src]="preview.url" class="rounded border" style="width: 100px; height: 75px; object-fit: cover;" alt="Preview" />
                      <button class="btn btn-sm btn-danger position-absolute" style="top: 20px; right: 0px; padding: 0 5px;" (click)="removeEditVehicleImage(i)">
                        &times;
                      </button>
                    </div>
                  </div>
                </div>
                
                <div class="col-12 d-flex justify-content-end gap-2 mt-4">
                  <button class="btn btn-outline-secondary" (click)="cancelEditVehicle()" [disabled]="isSavingVehicle">Cancel</button>
                  <button class="btn btn-primary" (click)="saveVehicleDetails()" [disabled]="isSavingVehicle">
                    <span *ngIf="isSavingVehicle" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                    Save Changes
                  </button>
                </div>
              </div>
            </div>

            <div *ngIf="vehicleImages.length > 0" class="col-12 d-flex flex-column vehicle-images-section">
              <div class="maindoc">
                <div class="blacky"></div>

                <div class="wrapp-vish">
                  <div class="vehicle-image-stage">
                    <div class="car-image-container">
                      <img [src]="vehicleImages[currentIndex].imageUrl"
                        [alt]="vehicleImages[currentIndex].imageType + ' View'" style="height: 100%" />
                    </div>
                  </div>

                  <div class="wrapper-buttons">
                    <div class="d-flex gap-2">
                      <p style="font-weight: 500">
                        {{ vehicleImages[currentIndex].imageType }} View
                      </p>
                      <p style="font-weight: 500">
                        {{ currentIndex + 1 }}/{{ vehicleImages.length }}
                      </p>
                    </div>

                    <div>
                      <img src="/assets/userIcon/Previous Icon.svg" alt="Previous" (click)="previousImage()"
                        style="margin-right: 5px; cursor: pointer" />

                      <img src="/assets/userIcon/Next Icon.svg" alt="Next" (click)="nextImage()"
                        style="cursor: pointer" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="vehicleImages.length <= 0" style="
                height: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
              ">
              <p style="font-weight: 500; color: #6d6d6d">
                No Vehicle Images Uploaded By TourGuide
              </p>
            </div>
          </div>
          <div></div>

          <!-- Unavailable Dates Section -->
          <div *ngIf="viewMode === 'unavailability'" class="canvas-section w-100">
            <div class="unavailability-wrapper h-100 mt-4 px-3 d-flex flex-column">
              <h5 class="mb-2" style="color: #4b4b4b; font-weight: 600;">Tour Guide Unavailability</h5>
              <p class="text-muted small mb-4">Click dates below to toggle them as unavailable. The guide will not receive bookings on these days.</p>
              
              <div class="calendar-container">
                <div class="calendar-header mb-3 mt-2">
                  <button class="btn btn-outline-secondary btn-sm rounded-circle px-2 custom-arrow" (click)="prevMonth()">&lt;</button>
                  <h6 class="m-0 fw-bold fs-5" style="color:#267D89">{{ currentMonth | date:'MMMM yyyy' }}</h6>
                  <button class="btn btn-outline-secondary btn-sm rounded-circle px-2 custom-arrow" (click)="nextMonth()">&gt;</button>
                </div>

                <div class="calendar-grid">
                  <!-- Weekday headers -->
                  <div class="weekday-header text-muted fw-bold text-center py-2" *ngFor="let day of weekDays">
                    {{ day }}
                  </div>

                  <!-- Calendar Days -->
                  <div class="calendar-day text-center"
                       *ngFor="let day of calendarDays"
                       [ngClass]="{
                          'other-month': !day.isCurrentMonth,
                          'past-date': day.isPast,
                          'unavailable': day.isUnavailable
                       }"
                       (click)="toggleUnavailableDate(day)">
                    <span class="day-number">{{ day.dayNumber }}</span>
                  </div>
                </div>
              </div>

              <div class="d-flex justify-content-end mt-4 pt-3 border-top mb-3">
                <button class="btn save-changes-btn px-4 py-2" (click)="saveUnavailableDates()">Save Changes</button>
              </div>
            </div>
          </div>

          <div class="col-11 history-table" *ngIf="viewMode === 'history'">
            <div class="table-bar border-bottom d-flex justify-content-between align-items-center py-2 px-2">
              <h5 class="history-header">Booking History</h5>
              <div class="table-controls d-flex align-items-center gap-2">
                <div class="search-wrapper d-flex align-items-center rounded searches">
                  <img class="table-img me-2" src="/assets/userIcon/searchIcon.png" alt="Search" width="16"
                    id="tableimgs" height="16" />
                  <input id="inputsearcha" class="input-search" type="text" placeholder="Search by name or email id"
                    (input)="onSearchInput($event)" />
                </div>
                <select id="userdroup" class="form-select userdroup" style="width: auto" [(ngModel)]="selectedfilter"
                  (change)="onStatusChange()">
                  <option selected value="">All</option>
                  <option value="Completed">Completed</option>
                  <option value="Pending">Pending</option>
                  <option value="Cancelled">Cancelled</option>
                  <option value="Confirmed">Upcoming</option>
                </select>
              </div>
            </div>

            <div class="scrollable2">
              <table class="table align-middle mb-0 border-1px">
                <thead class="custom-head">
                  <tr class="trow border-bottom">
                    <th scope="col" style="width: 13%">Booking ID</th>
                    <th scope="col" style="width: 10%">Location</th>
                    <th scope="col" *ngIf="getuserid.roleId == 2" style="width: 23%">
                      Guide
                    </th>
                    <th *ngIf="getuserid.roleId == 3" scope="col" style="width: 23%">
                      Tourist
                    </th>
                    <th scope="col" style="width: 24%">Trip Dates</th>
                    <th scope="col" style="width: 16%">Status</th>
                    <th scope="col" style="width: 10%">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngIf="
                      BookingHistory == null || BookingHistory.length === 0
                    ">
                    <td colspan="7" class="text-center py-3 text-muted">
                      No Booking Available.
                    </td>
                  </tr>

                  <tr *ngFor="let booking of BookingHistory">
                    <td>
                      <span class="bookid">BK-{{ booking.bookingId }}</span>
                    </td>

                    <td class="location">
                      <span>{{ booking.tourLocation }}</span>
                    </td>

                    <td *ngIf="getuserid.roleId == 2">
                      <div class="d-flex align-items-center gap-2 guide">
                        <img [src]="booking.tourGuideProfilePhotoUrl" class="rounded-circle" width="40" height="40"
                          style="cursor: pointer" data-bs-toggle="modal" data-bs-target="#guidePhotoPreviewModal"
                          (click)="openPhotoPreview(booking.tourGuideProfilePhotoUrl)" />
                        <div>
                          <div class="fw-semibold">{{ booking.guideName }}</div>
                          <div class="text-muted small email">
                            {{ booking.tourGuideEmail }}
                          </div>
                        </div>
                      </div>
                    </td>

                    <td *ngIf="getuserid.roleId == 3">
                      <div class="d-flex align-items-center gap-2 guide">
                        <img [src]="booking.touristProfilePhotoUrl" class="rounded-circle" width="40" height="40"
                          style="cursor: pointer" data-bs-toggle="modal" data-bs-target="#guidePhotoPreviewModal"
                          (click)="openPhotoPreview(booking.touristProfilePhotoUrl)" />
                        <div>
                          <div class="fw-semibold">
                            {{ booking.touristName }}
                          </div>
                          <div class="text-muted small">
                            {{ booking.touristEmail }}
                          </div>
                        </div>
                      </div>
                    </td>

                    <td class="dates" style="font-size: 0.8vw">
                      {{ booking.tourStartDate | date: "MMM dd, yyyy" }} -
                      {{ booking.tourEndDate | date: "MMM dd, yyyy" }}
                      <div class="Tripdates">
                        ({{ getRemainingDayss(booking.tourEndDate) }} days
                        remaining)
                      </div>
                    </td>
                    <td class="status-td">
                      <span [ngClass]="getStatusClass(booking.bookingStatus)">
                        <img [src]="getStatusIcon(booking.bookingStatus)" width="17" height="17" />
                        {{
                        booking.bookingStatus === "Confirmed"
                        ? "Upcoming"
                        : booking.bookingStatus
                        }}
                      </span>
                    </td>

                    <td class="action-img">
                      <img src="/assets/userIcon/Action.svg" width="24" height="24" style="cursor: pointer"
                        data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight3" aria-controls="offcanvasRight"
                        (click)="SetSelectedBooking(booking)" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="bottomtable1">
              <div></div>
              <app-pegination [pageAll]="BookingHistorypageNumber" [totalPages]="BookingHistorytotalbookingpage"
                [pageSize]="BookinghistorypageSize" (pageChange)="goToHistoryPages($event)"
                (sizeChange)="onHistorySizeChanges($event)">
              </app-pegination>
            </div>
          </div>
        </div>
        <div *ngIf="viewMode === 'documents'" class="col-12 d-flex flex-column vehicle-images-section canvas-section">
          
          <div class="d-flex justify-content-end mb-3 mt-2">
            <button *ngIf="!isEditingDocuments" class="btn btn-sm btn-outline-primary" (click)="startEditDocuments()">
              <i class="bi bi-pencil"></i> Edit Documents
            </button>
          </div>

          <!-- Read-only View -->
          <div class="maindoc" *ngIf="!isEditingDocuments">
            <div class="blacky"></div>
            <!-- Bootstrap Carousel -->

            <div class="wrapp-vish">
              <div *ngIf="documentImages.length > 0" class="vehicle-image-stage">
                <div class="image-container" (click)="openZoom(documentImages[currentIndex].url)">
                  <img [src]="
                        documentImages[currentIndex].url ||
                        '/assets/userIcon/doc.png '
                      " style="height: inherit; cursor: zoom-in;" />
                </div>
              </div>

              <div class="wrapper-buttons">
                <p>
                  <b>
                    {{ documentImages[currentIndex].label }} ({{
                    currentIndex + 1
                    }}/{{ documentImages.length }})</b>
                </p>

                <div>
                  <img src="/assets/userIcon/Previous Icon.svg" class="" alt="..." data-bs-target="#carouselExample"
                    data-bs-slide="prev" (click)="showPrevious()" style="margin-right: 5px; cursor: pointer" />
                  <img src="/assets/userIcon/Next Icon.svg" class="" alt="..." data-bs-target="#carouselExample"
                    data-bs-slide="next" (click)="showNext()" max="3" style="cursor: pointer" />
                </div>
              </div>
            </div>
          </div>

          <!-- Edit View -->
          <div *ngIf="isEditingDocuments" class="vehicle-info-wrapper mt-3">
            <div class="row g-3">
              
              <div class="col-md-12">
                <label class="form-label" style="color: #6d6d6d">Gov ID Type</label>
                <input type="text" class="form-control" [(ngModel)]="editDocumentGovIdType" placeholder="e.g. Passport, National ID, etc." />
              </div>

              <div class="col-md-6 border rounded p-3 position-relative">
                <label class="form-label fw-bold d-block mb-3" style="color: #4b4b4b">Government ID Front</label>
                <input type="file" class="form-control" accept="image/*" (change)="onGovIdFileSelected($event)" />
                <div class="mt-3 position-relative d-inline-block" *ngIf="editDocumentGovIdPreview">
                  <img [src]="editDocumentGovIdPreview" class="rounded border" style="width: 120px; height: 90px; object-fit: cover;" alt="Gov ID Front Preview" />
                  <button class="btn btn-sm btn-danger position-absolute" style="top: -10px; right: -10px; padding: 0 5px;" (click)="removeGovIdPreview()">
                    &times;
                  </button>
                </div>
              </div>

              <div class="col-md-6 border rounded p-3 position-relative">
                <label class="form-label fw-bold d-block mb-3" style="color: #4b4b4b">Government ID Back</label>
                <input type="file" class="form-control" accept="image/*" (change)="onGovIdBackFileSelected($event)" />
                <div class="mt-3 position-relative d-inline-block" *ngIf="editDocumentGovIdBackPreview">
                  <img [src]="editDocumentGovIdBackPreview" class="rounded border" style="width: 120px; height: 90px; object-fit: cover;" alt="Gov ID Back Preview" />
                  <button class="btn btn-sm btn-danger position-absolute" style="top: -10px; right: -10px; padding: 0 5px;" (click)="removeGovIdBackPreview()">
                    &times;
                  </button>
                </div>
              </div>

              <div class="col-md-6 border rounded p-3 position-relative">
                <label class="form-label fw-bold d-block mb-3" style="color: #4b4b4b">Licence Front Image</label>
                <input type="file" class="form-control" accept="image/*" (change)="onLicenceFileSelected($event)" />
                <div class="mt-3 position-relative d-inline-block" *ngIf="editDocumentLicencePreview">
                  <img [src]="editDocumentLicencePreview" class="rounded border" style="width: 120px; height: 90px; object-fit: cover;" alt="Licence Front Preview" />
                  <button class="btn btn-sm btn-danger position-absolute" style="top: -10px; right: -10px; padding: 0 5px;" (click)="removeLicencePreview()">
                    &times;
                  </button>
                </div>
              </div>

              <div class="col-md-6 border rounded p-3 position-relative">
                <label class="form-label fw-bold d-block mb-3" style="color: #4b4b4b">Licence Back Image</label>
                <input type="file" class="form-control" accept="image/*" (change)="onLicenceBackFileSelected($event)" />
                <div class="mt-3 position-relative d-inline-block" *ngIf="editDocumentLicenceBackPreview">
                  <img [src]="editDocumentLicenceBackPreview" class="rounded border" style="width: 120px; height: 90px; object-fit: cover;" alt="Licence Back Preview" />
                  <button class="btn btn-sm btn-danger position-absolute" style="top: -10px; right: -10px; padding: 0 5px;" (click)="removeLicenceBackPreview()">
                    &times;
                  </button>
                </div>
              </div>

              <div class="col-12 d-flex justify-content-end gap-2 mt-4">
                <button class="btn btn-outline-secondary" (click)="cancelEditDocuments()" [disabled]="isSavingDocuments">Cancel</button>
                <button class="btn btn-primary" (click)="saveDocumentDetails()" [disabled]="isSavingDocuments">
                  <span *ngIf="isSavingDocuments" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                  Save Changes
                </button>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

  <div class="container-fluid">
    <div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasRight23" aria-labelledby="offcanvasRightLabel"
      style="width: 40%">
      <div class="canva-head">
        <h5 class="offcanvas-title" id="offcanvasRightLabel" *ngIf="!rejection">
          Review Application
        </h5>
        <h5 class="offcanvas-title" id="offcanvasRightLabel" *ngIf="rejection">
          Application Rejection
        </h5>
        <button #closeBtn type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"
          (click)="backonform()"></button>
      </div>
      <div class="offcanvas-body" style="padding: 0; height: 94vh; overflow-y: auto; padding-inline: 2rem">
        <div class="contanier" style="height: 100%">
          <div *ngIf="!rejection" style="height: 100%">
            <div class="tab-wrapper">
              <div class="col-12 d-flex radiobtn" style="background-color: #f6f6f6; gap: 20px; height: 50px">
                <!-- Tab: Overview -->
                <label [class.active-tab]="selectguideTabs === 'overview'"
                  class="tab d-flex justify-content-center align-items-center">
                  <input type="radio" name="tab" hidden [checked]="selectguideTabs === 'overview'"
                    (change)="selectguideTab('overview')" />
                  <span class="fs-5">Overview</span>
                </label>

                <!-- Tab: Verification -->
                <label [class.active-tab]="selectguideTabs === 'verifaication'"
                  class="tab d-flex justify-content-center align-items-center">
                  <input type="radio" name="tab" hidden [checked]="selectguideTabs === 'verifaication'"
                    (change)="selectguideTab('verifaication')" />
                  <span class="fs-5">Verification Documents</span>
                </label>

                <!-- Tab: Rejection Reasons -->
                <label *ngIf="guideuser?.rejectionReasons?.length > 0 || guideuser?.reasonText" [class.active-tab]="selectguideTabs === 'rejectionReasons'"
                  class="tab d-flex justify-content-center align-items-center">
                  <input type="radio" name="tab" hidden [checked]="selectguideTabs === 'rejectionReasons'"
                    (change)="selectguideTab('rejectionReasons')" />
                  <span class="fs-5" style="white-space: nowrap;">Rejection Reasons</span>
                </label>
              </div>
            </div>

            <div *ngIf="selectguideTabs === 'overview'">
              <div class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-5">
                <div class="d-flex align-items-center gap-2">
                  <img [src]="guideuser.profilePhotoUrl || 'assets/userIcon/user.png'"
                    class="rounded-circle guide-profile-photo" width="96" height="96" data-bs-toggle="modal"
                    data-bs-target="#guidePhotoPreviewModal" (click)="openPhotoPreview(guideuser.profilePhotoUrl)" />
                </div>
              </div>

              <!-- Rejection reasons moved to its own tab -->

              <div
                class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-2 border-bottom">
                <p style="color: #6d6d6d">First Name</p>
                <span>
                  {{ guideuser.firstName }}
                </span>
              </div>
              <div
                class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-2 border-bottom">
                <p style="color: #6d6d6d">Last Name</p>
                <span>
                  {{ guideuser.lastName }}
                </span>
              </div>
              <!-- <div
                class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-2 border-bottom ">
                <p style="color: #6D6D6D;">Display Name </p>
                <span>
                  {{guideuser.firstName}}

                </span>

              </div> -->
              <div
                class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-2 border-bottom">
                <p style="color: #6d6d6d">Gender</p>
                <span>
                  {{ guideuser.gender }}
                </span>
              </div>
              <div
                class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-2 border-bottom">
                <p style="color: #6d6d6d">Email</p>
                <span>
                  {{ guideuser.email }}
                </span>
              </div>
              <div
                class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-2 border-bottom">
                <p style="color: #6d6d6d">Contact</p>
                <span>
                 +{{ guideuser.dialCode }}{{ guideuser.phoneNumber }}
                </span>
              </div>
              <div
                class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-2 border-bottom">
                <p style="color: #6d6d6d">Country</p>
                <span *ngIf="guideuser?.countryCode">
                  <span class="fi" [ngClass]="'fi-' + guideuser.countryCode.toLowerCase()"></span>
                  {{ guideuser.country }}
                </span>
              </div>
              <div
                class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-2 border-bottom">
                <p style="color: #6d6d6d">Service Location</p>
                <span>
                  {{ guideuser.location }}
                </span>
              </div>
              <div
                class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-2 border-bottom">
                <p style="color: #6d6d6d">Home Town</p>
                <span>
                  {{ guideuser.homeTown ? guideuser.homeTown : 'N/A' }}
                </span>
              </div>
              <div
                class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-2 border-bottom">
                <p style="color: #6d6d6d">Date of Birth</p>
                <span>
                  {{ guideuser.dateOfBirth ? (guideuser.dateOfBirth | date:'MM/dd/yyyy') : 'N/A' }}
                </span>
              </div>

              <div
                class="col-12 d-flex justify-content-between align-items-start mt-2 border-bottom py-2">
                <p style="color: #6d6d6d; white-space: nowrap; margin-right: 15px; margin-bottom: 0px; padding-top: 5px;">Known Languages</p>

                <div class="d-flex flex-wrap gap-2 justify-content-end">
                  <span *ngFor="let lang of guideuser.languages">
                    <span class="lang-name">{{ lang.languageName }}</span>
                  </span>
                </div>
              </div>

              <div *ngIf="guideuser?.vehicles?.length" class="mt-4">
                <div *ngIf="guideVehicleViewMode === 'overview' && selectedGuideVehicle" class="outer-wrapper">
                  <div class="vehicle-details-wrapper">
                    <div class="car-photo">
                      <img [src]="getVehicleImageUrl(selectedGuideVehicle, 'Front')" alt="Vehicle Photo"
                        style="border-radius: 8px" width="100%" height="100%" />
                    </div>
                    <div class="inner-vehicle-details">
                      <div class="car-name">
                        <span style="font-weight: 600">
                          {{ selectedGuideVehicle.vehicleBrandName }}
                          {{ selectedGuideVehicle.vehicleModelName }}
                        </span>
                      </div>

                      <div class="car-number" style="color: #6d6d6d">
                        {{ selectedGuideVehicle.licensePlateNumber }}
                      </div>

                      <div class="car-summary">
                        <img src="/assets/userIcon/carIcon.svg" alt="Car Icon" />
                        <span>{{ selectedGuideVehicle.noOfSeats }} Seats</span>
                        <span>{{ selectedGuideVehicle.noOfDoors }} Doors</span>
                        <span *ngIf="selectedGuideVehicle?.isAirConditioner">Air Conditioning</span>
                      </div>
                    </div>
                  </div>

                  <div class="bttn-outer">
                    <div class="details-btn" (click)="toggleGuideVehicleView('vehicleDetails')">
                      <img src="/assets/userIcon/detailsIcon.svg" alt="Details Icon" width="24" height="24" />

                    </div>
                  </div>
                </div>

                <div *ngIf="guideVehicleViewMode === 'vehicleDetails' && selectedGuideVehicle != null"
                  class="canvas-section">
                  <div class="vehicle-info-wrapper">
                    <div
                      class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-2 border-bottom">
                      <p style="color: #6d6d6d">Vehicle Brand</p>
                      <span>{{ selectedGuideVehicle.vehicleBrandName }}</span>
                    </div>
                    <div
                      class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-2 border-bottom">
                      <p style="color: #6d6d6d">Vehicle Model</p>
                      <span>{{ selectedGuideVehicle.vehicleModelName }}</span>
                    </div>
                    <div
                      class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-2 border-bottom">
                      <p style="color: #6d6d6d">Tourguide Hourly Charges</p>
                      <span>{{ selectedGuideVehicle.hourlyRate }}$</span>
                    </div>
                    <div
                      class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-2 border-bottom">
                      <p style="color: #6d6d6d">License Plate Number</p>
                      <span>{{ selectedGuideVehicle.licensePlateNumber }}</span>
                    </div>
                    <div
                      class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-2 border-bottom">
                      <p style="color: #6d6d6d">No. Of Seats</p>
                      <span>{{ selectedGuideVehicle.noOfSeats }}</span>
                    </div>
                    <div
                      class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-2 border-bottom">
                      <p style="color: #6d6d6d">No. Of Doors</p>
                      <span>{{ selectedGuideVehicle.noOfDoors }}</span>
                    </div>
                    <div
                      class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-2 border-bottom">
                      <p style="color: #6d6d6d">Air Conditioning</p>
                      <span>{{ selectedGuideVehicle.isAirConditioner ? 'Yes' : 'No' }}</span>
                    </div>
                  </div>

                  <div *ngIf="guideVehicleImages.length > 0" class="col-12 d-flex flex-column vehicle-images-section">
                    <div class="maindoc">
                      <div class="blacky"></div>

                      <div class="wrapp-vish">
                        <div class="vehicle-image-stage">
                          <div class="car-image-container">
                            <img [src]="guideVehicleImages[guideVehicleIndex].imageUrl"
                              [alt]="guideVehicleImages[guideVehicleIndex].imageType + ' View'" style="height: 100%" />
                          </div>
                        </div>

                        <div class="wrapper-buttons">
                          <div class="d-flex gap-2">
                            <p style="font-weight: 500">
                              {{ guideVehicleImages[guideVehicleIndex].imageType }} View
                            </p>
                            <p style="font-weight: 500">
                              {{ guideVehicleIndex + 1 }}/{{ guideVehicleImages.length }}
                            </p>
                          </div>

                          <div>
                            <img src="/assets/userIcon/Previous Icon.svg" alt="Previous"
                              (click)="guidePreviousVehicleImage()" style="margin-right: 5px" />
                            <img src="/assets/userIcon/Next Icon.svg" alt="Next" (click)="guideNextVehicleImage()" />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="mt-3">
                      <div class="details-btn" (click)="toggleGuideVehicleView('overview')">
                        <span style="color: #309eae; font-weight: 600">close</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="outer-wrapper">
              <div class="vehicle-details-wrapper">
                <div class="car-photo">
                  <img [src]="getFrontImageUrl()" alt="Car Photo" style="border-radius: 8px;" width="100%"
                    height="100%" />

                </div>
                <div class="inner-vehicle-details">

                  <div class="car-name"><span style="font-weight: 600;">{{guideuser.vehicleBrandName}}
                      {{guideuser.vehicleModelName}}</span></div>

                  <div class="car-number" style="color: #6D6D6D;">{{guideuser.licensePlateNumber}}</div>

                  <div class="car-summary">
                    <img src="/assets/userIcon/carIcon.svg" alt="Car Icon" />
                    <span>{{guideuser.noOfSeats}} Seats</span>
                    <span>{{guideuser.noOfDoors}} Doors</span>
                    <span *ngIf="guideuser?.isAirConditioner">Air Conditioning</span>
                  </div>


                </div>

              </div>
              <div class="bttn-outer">
                <div class="details-btn" (click)="toggleView('vehicleDetails')">
                  <img src="/assets/userIcon/detailsIcon.svg" alt="Details Icon" width="24" height="24" />
                  <span style="color: #309EAE; font-weight: 600;">View Details</span>
                </div>
              </div>
            </div> -->

            </div>

            <div *ngIf="selectguideTabs === 'verifaication'" class="col-12 d-flex flex-column vehicle-images-section">
              <div class="maindoc">
                <div class="blacky"></div>
                <!-- Bootstrap Carousel -->

                <div class="wrapp-vish">
                  <div *ngIf="documentImages.length > 0" class="vehicle-image-stage">
                    <div class="image-container" (click)="openZoom(documentImages[currentIndex].url)">
                      <img [src]="
                        documentImages[currentIndex].url ||
                        '/assets/userIcon/doc.png '
                      " style="height: inherit; cursor: zoom-in;" />
                    </div>
                  </div>

                  <div class="wrapper-buttons">
                    <p>
                      <b>
                        {{ documentImages[currentIndex].label }} ({{
                        currentIndex + 1
                        }}/{{ documentImages.length }})</b>
                    </p>

                    <div>
                      <img src="/assets/userIcon/Previous Icon.svg" class="" alt="..." data-bs-target="#carouselExample"
                        data-bs-slide="prev" (click)="showPrevious()" style="margin-right: 5px" />
                      <img src="/assets/userIcon/Next Icon.svg" class="" alt="..." data-bs-target="#carouselExample"
                        data-bs-slide="next" (click)="showNext()" max="3" />
                    </div>
                  </div>
                </div>
              </div>

              <div *ngIf="selectedTab !== 'RejectedApplication'" style="
                  display: flex;
                  justify-content: space-between;
                  margin-bottom: 10px;
                ">
                <button class="btnapprove" style="width: 45%; margin-right: 5px; font-size: 1vw" id="reject"
                  (click)="onrejection()">
                  Reject Guide Application
                </button>
                <button class="btnapprove" style="width: 45%; font-size: 1vw" (click)="ApproveGuideReq()">
                  Approve Guide Application
                </button>
              </div>
            </div>

            <div *ngIf="selectguideTabs === 'rejectionReasons'" class="p-3">
              <div class="border rounded bg-light p-4" style="border-left: 4px solid #dc3545 !important;">
                <h6 class="text-danger fw-bold mb-3 fs-5">Rejection Reasons</h6>
                <ul class="mb-0 text-dark fs-6" style="word-break: break-word; padding-left: 1.5rem;" *ngIf="guideuser?.rejectionReasons?.length > 0">
                  <li *ngFor="let reason of guideuser.rejectionReasons" class="mb-2">{{ reason }}</li>
                </ul>
                <p class="mb-0 text-dark fs-6" style="word-break: break-word;" *ngIf="!guideuser?.rejectionReasons?.length && guideuser?.reasonText">{{ guideuser.reasonText }}</p>
                
                <ng-container *ngIf="guideuser?.optionalReason">
                  <h6 class="text-danger fw-bold mt-4 mb-2 fs-5">Optional Feedback</h6>
                  <p class="mb-0 text-dark fs-6" style="word-break: break-word;">{{ guideuser.optionalReason }}</p>
                </ng-container>
              </div>
            </div>
          </div>
          <div *ngIf="rejection" class="wrapper-rejection">
            <div class="reason-wrapper">
              <h5>Select Issue for Application Rejection:</h5>

              <div class="col-12" *ngFor="let section of uniqueSections; let i = index">
                <p class="fw-semibold mt-3">{{ i + 1 }}. {{ section }}</p>

                <ng-container *ngFor="let reason of rectionarray">
                  <ng-container *ngIf="reason.sectionName === section">
                    <div class="form-check mb-2 ms-3">
                      <input type="checkbox" class="form-check-input checkboxsize" [id]="'reason' + reason.reasonId"
                        (change)="toggleReason(reason.reasonId, reason.reasonText, $event)" />
                      <label class="form-check-label" [for]="'reason' + reason.reasonId">
                        {{ reason.reasonText }}
                      </label>
                    </div>
                  </ng-container>
                </ng-container>
              </div>

              <div class="row">
                <div class="col-11">
                  <p class="fw-semibold" style="margin-top: 10px">
                    Rejection Reason (Optional)
                  </p>
                </div>
              </div>

              <div class="position-relative">
                <textarea class="form-control custom-textarea" placeholder="Enter reason for application rejection"
                  maxlength="300" rows="5" [(ngModel)]="othermsg"></textarea>
                <div class="char-counter text-muted">300</div>
              </div>
            </div>

            <div class="rjection_btnWrapper">
              <div style="display: flex; justify-content: center; width: 100%">
                <button class="reject" id="reject" (click)="rejectapplication()">
                  Reject Guide Application
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid">
      <div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasRight3" aria-labelledby="offcanvasRightLabel"
        data-bs-backdrop="static">
        <app-booking-canvas [selectedBooking]="selectedBooking"
          (closeCanvas)="closeBookingOffCanava()"></app-booking-canvas>
      </div>
    </div>

    <div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasRight0" aria-labelledby="offcanvasRightLabel"
      style="width: 45%">
      <div class="offcanvas-header">
        <h5 class="offcanvas-title" id="offcanvasRightLabel">User Details</h5>
        <button #closeBtn2 type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"
          (click)="closeCanvas()"></button>
      </div>
      <div class="offcanvas-body">
        <div class="container">
          <div class="row">
            <div class="col-12 d-flex radiobtn insidetab" style="background-color: #f6f6f6; gap: 20px">
              <div class="tab1" [ngClass]="{ 'active-tab': viewMode === 'overview' }" (click)="toggleView('overview')">
                <span class="d-flex justify-content-center align-items-center opentickit">
                  <span class="lbl-class">Overview</span>
                </span>
              </div>

              <!-- <div class="tab1" [ngClass]="{'active-tab': viewMode === 'history'}" (click)="toggleView('payout')">
                <span class="d-flex justify-content-center align-items-center opentickit">
                  <span class="lbl-class">Vehicles</span>
                </span>
              </div> -->
            </div>

            <div *ngIf="viewMode === 'overview'">
              <div class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-5">
                <div class="d-flex align-items-center gap-2">
                  <img src="{{ getuserid.profilePhotoUrl }}" class="rounded-circle" width="40" height="40"
                    style="cursor: pointer" data-bs-toggle="modal" data-bs-target="#guidePhotoPreviewModal"
                    (click)="openPhotoPreview(getuserid.profilePhotoUrl)" />
                  <div>
                    <div class="fw-semibold" style="
                        width: 25vw;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        max-width: 100%;
                      ">
                      {{ getuserid.firstName }} {{ getuserid.lastName }}
                    </div>
                    <div class="text-muted small">{{ getuserid.email }}</div>
                  </div>
                </div>

                <span *ngIf="!getuserid.isDeactivate" class="Active status">
                  <span class="dot"></span> Active
                </span>
                <span *ngIf="getuserid.isDeactivate" class="Inactive status">
                  <span class="dot"></span> Inactive
                </span>
              </div>
              <div
                class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-5 border-bottom">
                <p>User Type</p>
                <span class="tourist" *ngIf="getuserid.roleId == 2">
                  <img src="/assets/userIcon/tourist.png" class="me-1" />
                  Tourist
                </span>
                <span class="guides" *ngIf="getuserid.roleId == 3">
                  <img src="/assets/userIcon/Guide.png" class="me-1" />
                  Guide</span>
              </div>

              <div
                class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-2 border-bottom">
                <p style="color: #6d6d6d">First Name</p>
                <div class="editable-field">
                  <!-- Input + Cross icon when editing -->
                  <div class="d-flex align-items-center" *ngIf="editFields['firstName']">
                    <input class="inputtype" type="text" [(ngModel)]="getuserid.firstName" />
                    <p>
                      <img src="assets/content-manager/cross.svg" style="cursor: pointer; margin-left: 1rem"
                        (click)="toggleInput('firstName')" />
                    </p>
                  </div>

                  <!-- Display text + Add icon when not editing -->
                  <div class="editable-field" *ngIf="!editFields['firstName']">
                    <p class="Uname">{{ getuserid.firstName }}</p>
                    <p>
                      <img src="assets/content-manager/Add.png" (click)="toggleInput('firstName')"
                        style="cursor: pointer; margin-left: 1rem" />
                    </p>
                  </div>
                </div>
              </div>
              <div
                class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-2 border-bottom">
                <p style="color: #6d6d6d">Last Name</p>
                <div class="editable-field">
                  <!-- Input + Cross icon when editing -->
                  <div class="d-flex align-items-center" *ngIf="editFields['lastName']">
                    <input class="inputtype" type="text" [(ngModel)]="getuserid.lastName" />
                    <p>
                      <img src="assets/content-manager/cross.svg" style="cursor: pointer; margin-left: 1rem"
                        (click)="toggleInput('lastName')" />
                    </p>
                  </div>

                  <!-- Display text + Add icon when not editing -->
                  <div class="editable-field" *ngIf="!editFields['lastName']">
                    <p class="Uname">{{ getuserid.lastName }}</p>
                    <p>
                      <img src="assets/content-manager/Add.png" (click)="toggleInput('lastName')"
                        style="cursor: pointer; margin-left: 1rem" />
                    </p>
                  </div>
                </div>
              </div>
              <!-- <div
                class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-2 border-bottom ">
                <p style="color: #6D6D6D;">Display Name </p>
                <span>{{getuserid.displayName}}</span>
              </div> -->
              <div
                class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-2 border-bottom">
                <p style="color: #6d6d6d">Gender</p>
                <span>{{ getuserid.gender }}</span>
              </div>
              <div
                class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-2 border-bottom">
                <p style="color: #6d6d6d">E mail</p>
                <div>
                  <!-- Input + Cross icon when editing -->
                  <div class="d-flex align-items-center" *ngIf="editFields['email']">
                    <input class="inputtype" type="text" [(ngModel)]="getuserid.email" />
                    <p>
                      <img src="assets/content-manager/cross.svg" style="cursor: pointer"
                        (click)="toggleInput('email')" />
                    </p>
                  </div>

                  <!-- Display text + Add icon when not editing -->
                  <span class="d-flex" *ngIf="!editFields['email']">
                    <p>{{ getuserid.email }}</p>
                  </span>
                </div>
              </div>
              <div *ngIf="getuserid.roleId === 3"
                class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-2 border-bottom">
                <p style="color: #6d6d6d">Contact</p>
                <span>
                  +{{ getuserid.dialCode }}{{ getuserid.phoneNumber }}
                </span>
              </div>
              <div *ngIf="getuserid.roleId === 3"
                class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-2 border-bottom">
                <p style="color: #6d6d6d">Country</p>
                <span *ngIf="guideuser?.countryCode">
                  <span class="fi" [ngClass]="'fi-' + guideuser.countryCode.toLowerCase()"></span>
                  {{ guideuser.country }}
                </span>
              </div>
              <div *ngIf="getuserid.roleId === 3"
                class="col-12 d-flex justify-content-between justify-content-center align-items-center mt-2 border-bottom">
                <p style="color: #6d6d6d">Know Languages</p>
                <span>
                  <div>
                    <span style="margin-inline: 2px" *ngFor="let lang of getuserid.languages">
                      <span class="lang-name">{{ lang.languageName }}</span>
                    </span>
                  </div>
                </span>
              </div>

              <div>
                <button class="btnapprove" style="width: 48%; margin-right: 5px; margin-top: 7rem" id="reject"
                  (click)="resetAllFields()">
                  Discard Changes
                </button>
                <button class="btnapprove" style="width: 48%" (click)="EditNameFun()">
                  Save Changes
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Change Request Offcanvas -->
  <div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasChangeRequest" aria-labelledby="offcanvasChangeRequestLabel" style="width: 40%">
    <div class="canva-head">
      <h5 class="offcanvas-title" id="offcanvasChangeRequestLabel">Change Request Details</h5>
      <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="canva-body p-4" style="overflow-y: auto; height: 90vh;">
      
      <!-- Loading State -->
      <div *ngIf="!selectedChangeRequestDetails" class="text-center mt-5 text-muted">
        <p>Loading details...</p>
      </div>

      <!-- Detail View -->
      <div *ngIf="selectedChangeRequestDetails">
        
        <!-- Header Info -->
        <div class="d-flex align-items-center gap-3 mb-4 border-bottom pb-3">
          <img [src]="selectedChangeRequestUser?.profilePhotoUrl || 'assets/userIcon/user.png'" class="rounded-circle" width="60" height="60" />
          <div>
            <h5 class="mb-0">{{ selectedChangeRequestUser?.fullName }}</h5>
            <small class="text-muted">{{ selectedChangeRequestUser?.email }}</small>
          </div>
        </div>

        <!-- Vehicle Changes section -->
        <div class="mb-4" *ngIf="selectedChangeRequestDetails.vehicleChanges">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <h6 class="fw-bold mb-0">Vehicle Details Update
              <span *ngIf="selectedChangeRequestDetails.vehicleStatus" class="badge ms-2" [ngClass]="{'bg-warning text-dark': selectedChangeRequestDetails.vehicleStatus === 'Pending', 'bg-success': selectedChangeRequestDetails.vehicleStatus === 'Approved', 'bg-danger': selectedChangeRequestDetails.vehicleStatus === 'Rejected'}">{{selectedChangeRequestDetails.vehicleStatus}}</span>
            </h6>
            <div *ngIf="selectedChangeRequestDetails.vehicleStatus === 'Pending'">
              <button class="btn btn-sm btn-outline-danger me-2" data-bs-toggle="modal" data-bs-target="#rejectReasonModal" (click)="openRejectModal('Vehicle')">Reject</button>
              <button class="btn btn-sm btn-outline-success" (click)="approveChangeRequest('Vehicle')">Approve</button>
            </div>
          </div>
          <div class="bg-light p-3 rounded">
            <p class="mb-1 text-muted small" *ngIf="selectedChangeRequestDetails.vehicleChanges.vehicleModelName || selectedChangeRequestDetails.vehicleChanges.vehicleBrandName">
              Brand/Model: <span class="text-dark fw-medium">{{selectedChangeRequestDetails.vehicleChanges.vehicleBrandName}} {{selectedChangeRequestDetails.vehicleChanges.vehicleModelName}}</span>
            </p>
            <p class="mb-1 text-muted small" *ngIf="selectedChangeRequestDetails.vehicleChanges.licensePlateNumber != null">
              License: <span class="text-dark fw-medium">{{selectedChangeRequestDetails.vehicleChanges.licensePlateNumber}}</span>
            </p>
            <p class="mb-1 text-muted small" *ngIf="selectedChangeRequestDetails.vehicleChanges.vehicleCharges != null">
              Hourly Charge: <span class="text-dark fw-medium">${{selectedChangeRequestDetails.vehicleChanges.vehicleCharges}}</span>
            </p>
            <p class="mb-1 text-muted small" *ngIf="selectedChangeRequestDetails.vehicleChanges.noOfSeats != null || selectedChangeRequestDetails.vehicleChanges.noOfDoors != null">
              <span *ngIf="selectedChangeRequestDetails.vehicleChanges.noOfSeats != null">Seats: <span class="text-dark fw-medium">{{selectedChangeRequestDetails.vehicleChanges.noOfSeats}}</span></span>
              <span *ngIf="selectedChangeRequestDetails.vehicleChanges.noOfSeats != null && selectedChangeRequestDetails.vehicleChanges.noOfDoors != null"> | </span>
              <span *ngIf="selectedChangeRequestDetails.vehicleChanges.noOfDoors != null">Doors: <span class="text-dark fw-medium">{{selectedChangeRequestDetails.vehicleChanges.noOfDoors}}</span></span>
            </p>
            <p class="mb-1 text-muted small" *ngIf="selectedChangeRequestDetails.vehicleChanges.isAirConditioner != null">
              AC: <span class="text-dark fw-medium">{{selectedChangeRequestDetails.vehicleChanges.isAirConditioner ? 'Yes' : 'No'}}</span>
            </p>
            <p class="mb-0 text-muted small" *ngIf="selectedChangeRequestDetails.vehicleChanges.noOfLargeBags != null || selectedChangeRequestDetails.vehicleChanges.noOfSmallBags != null">
              Bags: 
              <span class="text-dark fw-medium" *ngIf="selectedChangeRequestDetails.vehicleChanges.noOfLargeBags != null">{{selectedChangeRequestDetails.vehicleChanges.noOfLargeBags}} (Large)</span>
              <span *ngIf="selectedChangeRequestDetails.vehicleChanges.noOfLargeBags != null && selectedChangeRequestDetails.vehicleChanges.noOfSmallBags != null"> / </span>
              <span class="text-dark fw-medium" *ngIf="selectedChangeRequestDetails.vehicleChanges.noOfSmallBags != null">{{selectedChangeRequestDetails.vehicleChanges.noOfSmallBags}} (Small)</span>
            </p>
            <div *ngIf="selectedChangeRequestDetails.vehicleRemarks" class="mt-2 pt-2 border-top">
              <p class="mb-0 small text-danger">
                <strong>Rejection Reason:</strong> {{selectedChangeRequestDetails.vehicleRemarks}}
              </p>
            </div>
          </div>
        </div>

        <!-- Rate Changes section -->
        <div class="mb-4" *ngIf="selectedChangeRequestDetails.rateChanges">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <h6 class="fw-bold mb-0">Rate Update
              <span *ngIf="selectedChangeRequestDetails.rateStatus" class="badge ms-2" [ngClass]="{'bg-warning text-dark': selectedChangeRequestDetails.rateStatus === 'Pending', 'bg-success': selectedChangeRequestDetails.rateStatus === 'Approved', 'bg-danger': selectedChangeRequestDetails.rateStatus === 'Rejected'}">{{selectedChangeRequestDetails.rateStatus}}</span>
            </h6>
            <div *ngIf="selectedChangeRequestDetails.rateStatus === 'Pending'">
              <button class="btn btn-sm btn-outline-danger me-2" data-bs-toggle="modal" data-bs-target="#rejectReasonModal" (click)="openRejectModal('Rates')">Reject Rate</button>
              <button class="btn btn-sm btn-outline-success" (click)="approveChangeRequest('Rates')">Approve Rate</button>
            </div>
          </div>
          <div class="bg-light p-3 rounded">
            <p class="mb-0 text-muted small" *ngIf="selectedChangeRequestDetails.rateChanges.hourlyRate != null">
              Hourly Rate: <span class="text-dark fw-medium">${{selectedChangeRequestDetails.rateChanges.hourlyRate}}</span>
            </p>
            <div *ngIf="selectedChangeRequestDetails.rateRemarks" class="mt-2 pt-2 border-top">
              <p class="mb-0 small text-danger">
                <strong>Rejection Reason:</strong> {{selectedChangeRequestDetails.rateRemarks}}
              </p>
            </div>
          </div>
        </div>

        <!-- Image Changes section -->
        <div class="mb-4" *ngIf="selectedChangeRequestDetails.imageChanges && selectedChangeRequestDetails.imageChanges.length > 0">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <h6 class="fw-bold mb-0">Image Updates
              <span *ngIf="selectedChangeRequestDetails.imageStatus" class="badge ms-2" [ngClass]="{'bg-warning text-dark': selectedChangeRequestDetails.imageStatus === 'Pending', 'bg-success': selectedChangeRequestDetails.imageStatus === 'Approved', 'bg-danger': selectedChangeRequestDetails.imageStatus === 'Rejected'}">{{selectedChangeRequestDetails.imageStatus}}</span>
            </h6>
            <div *ngIf="selectedChangeRequestDetails.imageStatus === 'Pending'">
              <button class="btn btn-sm btn-outline-danger me-2" data-bs-toggle="modal" data-bs-target="#rejectReasonModal" (click)="openRejectModal('Images')">Reject Images</button>
              <button class="btn btn-sm btn-outline-success" (click)="approveChangeRequest('Images')">Approve Images</button>
            </div>
          </div>
          <div class="bg-light p-3 rounded">
            <div class="d-flex flex-wrap gap-3">
               <div *ngFor="let img of selectedChangeRequestDetails.imageChanges" class="text-center">
                   <img [src]="img.imageUrl" style="width: 100px; height: 100px; object-fit: cover; border-radius: 8px; cursor: pointer;" (click)="openZoom(img.imageUrl)"/>
                   <p class="small text-muted mt-1">{{img.imageType}} ({{img.actionType}})</p>
               </div>
            </div>
            <div *ngIf="selectedChangeRequestDetails.imageRemarks" class="mt-2 pt-2 border-top">
              <p class="mb-0 small text-danger">
                <strong>Rejection Reason:</strong> {{selectedChangeRequestDetails.imageRemarks}}
              </p>
            </div>
          </div>
        </div>

        <!-- Document Changes section -->
        <div class="mb-4" *ngIf="selectedChangeRequestDetails.documentChanges && selectedChangeRequestDetails.documentChanges.length > 0">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <h6 class="fw-bold mb-0">Verification Documents Update
              <span *ngIf="selectedChangeRequestDetails.documentStatus" class="badge ms-2" [ngClass]="{'bg-warning text-dark': selectedChangeRequestDetails.documentStatus === 'Pending', 'bg-success': selectedChangeRequestDetails.documentStatus === 'Approved', 'bg-danger': selectedChangeRequestDetails.documentStatus === 'Rejected'}">{{selectedChangeRequestDetails.documentStatus}}</span>
            </h6>
            <div *ngIf="selectedChangeRequestDetails.documentStatus === 'Pending'">
              <button class="btn btn-sm btn-outline-danger me-2" data-bs-toggle="modal" data-bs-target="#rejectReasonModal" (click)="openRejectModal('Documents')">Reject Documents</button>
              <button class="btn btn-sm btn-outline-success" (click)="approveChangeRequest('Documents')">Approve Documents</button>
            </div>
          </div>
          <div class="bg-light p-3 rounded">
            <div class="d-flex flex-wrap gap-3">
               <div *ngFor="let doc of selectedChangeRequestDetails.documentChanges" class="d-flex gap-3">
                   <div class="text-center" *ngIf="doc.frontImageUrl">
                       <img [src]="doc.frontImageUrl" style="width: 100px; height: 100px; object-fit: cover; border-radius: 8px; cursor: pointer;" (click)="openZoom(doc.frontImageUrl)"/>
                       <p class="small text-muted mt-1">{{doc.documentType}} Front ({{doc.actionType}})</p>
                   </div>
                   <div class="text-center" *ngIf="doc.backImageUrl">
                       <img [src]="doc.backImageUrl" style="width: 100px; height: 100px; object-fit: cover; border-radius: 8px; cursor: pointer;" (click)="openZoom(doc.backImageUrl)"/>
                       <p class="small text-muted mt-1">{{doc.documentType}} Back ({{doc.actionType}})</p>
                   </div>
               </div>
            </div>
            <div *ngIf="selectedChangeRequestDetails.documentRemarks" class="mt-2 pt-2 border-top">
              <p class="mb-0 small text-danger">
                <strong>Rejection Reason:</strong> {{selectedChangeRequestDetails.documentRemarks}}
              </p>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <!-- Document Zoom Overlay -->
  <div class="zoom-overlay" *ngIf="isZoomOverlayVisible" (click)="closeZoom()">
    <div class="zoom-controls" (click)="$event.stopPropagation()">
      <button class="zoom-btn" (click)="zoomIn()" title="Zoom In">
        <i class="bi bi-plus-lg">+</i>
      </button>
      <button class="zoom-btn" (click)="zoomOut()" title="Zoom Out">
        <i class="bi bi-dash-lg">-</i>
      </button>
      <button class="zoom-btn" (click)="resetZoom()" title="Reset Zoom">
        <i class="bi bi-arrow-counterclockwise">R</i>
      </button>
      <button class="zoom-btn close-btn" (click)="closeZoom()" title="Close">
        <i class="bi bi-x-lg">×</i>
      </button>
    </div>
    <div class="zoom-image-container" (click)="$event.stopPropagation()">
      <img [src]="zoomedImageUrl" [style.transform]="'scale(' + zoomScale + ')'" class="zoomed-image" />
    </div>
  </div>
  <!-- Reject Reason Modal -->
  <div class="modal fade" id="rejectReasonModal" tabindex="-1" aria-labelledby="rejectReasonModalLabel" aria-hidden="true" data-bs-backdrop="static" style="z-index: 1056;">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="rejectReasonModalLabel">Reject {{selectedEntityForRejection}} Updates</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" #closeRejectModalBtn></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label for="rejectionReason" class="form-label">Rejection Reason <span class="text-danger">*</span></label>
            <textarea class="form-control" id="rejectionReason" rows="4" [(ngModel)]="rejectionReason" placeholder="Please enter the rejection reason..."></textarea>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-danger" (click)="submitRejection()">Reject</button>
        </div>
      </div>
    </div>
  </div>

</body>